import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import cogoToast from "cogo-toast";

import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { proxy, useSnapshot } from "valtio";

import * as serviceWorker from './serviceworker';

// Global error handler for unhandled errors
// DISABLED: Redirect logic commented out to see actual errors
window.addEventListener('error', (event) => {
  // Only handle errors that are not already handled by Error Boundary
  // Skip script loading errors and other non-critical errors
  if (event.error && event.error.toString().includes('Script error')) {
    return; // Ignore cross-origin script errors
  }
  
  // Log error to console
  // console.error("Global error handler caught:", event.error, event);
  
  // // Show toast message
  // cogoToast.error("An error occurred. Please try again.", {
  //   hideAfter: 5,
  //   position: "top-right",
  // });
  
  // DISABLED: Redirect to dashboard
  // Uncomment below to re-enable redirect on errors
  /*
  const currentPath = window.location.pathname;
  if (currentPath !== '/dashboard' && currentPath !== '/login' && !currentPath.startsWith('/vendor/')) {
    // Small delay to ensure toast shows before redirect
    setTimeout(() => {
      window.location.href = '/dashboard';
    }, 100);
  }
  */
});

// Global handler for unhandled promise rejections
// DISABLED: Redirect logic commented out to see actual errors
window.addEventListener('unhandledrejection', (event) => {
  // Prevent default browser error handling
  event.preventDefault();
  
  // Log error to console
  console.error("Unhandled promise rejection:", event.reason, event);
  
  // Show toast message
  // cogoToast.error("An error occurred. Please try again.", {
  //   hideAfter: 5,
  //   position: "top-right",
  // });
  
  // DISABLED: Redirect to dashboard
  // Uncomment below to re-enable redirect on errors
  /*
  const currentPath = window.location.pathname;
  if (currentPath !== '/dashboard' && currentPath !== '/login' && !currentPath.startsWith('/vendor/')) {
    // Small delay to ensure toast shows before redirect
    setTimeout(() => {
      window.location.href = '/dashboard';
    }, 100);
  }
  */
});

// const state = proxy({ count: 21, text: "hello" });
ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
serviceWorker.register();